import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import {AppBackground} from '../../../components/app/app.styled';
import {HomeContainer} from '../../home/home-container';
import {ROUTES} from './routes';

export const AppRoutes = () => {
    return (
        <AppBackground>
            <Switch>
                <Route
                    exact
                    path={ROUTES.home}
                    component={HomeContainer}
                />
            </Switch>

            <Switch>
                <Route path="*" exact={true} render={() => (
                    <Redirect to={ROUTES.home}/>
                )}/>
            </Switch>
        </AppBackground>
    );
};
